export default __webpack_public_path__ + "static/management-e6f5f8ffa974850e2185efcd06533586.png";